{
  "advancededitor": {
    "Add entry": "Submit yer name",
    "Duplicate": "Duplicate",
    "Image attached": "Image attached",
    "Inherit from wheel": "Inherit from wheel",
    "Not shown on the wheel": "Not shown on the wheel",
    "Popup message": "Popup message",
    "Shown on the wheel": "Shown on the wheel",
    "Weight": "Ballast"
  },
  "app": {
    "Ads": "Ads",
    "Click here to report an inappropriate ad": "Click 'ere to report a scurvy ad.",
    "Click the Language menu": "Click the menu in the upper right to switch to English",
    "Close ad": "Close ad",
    "Common questions about using the random name picker wheel": "Common questions 'bout usin' the random name picker wheel",
    "Copy this wheel": "Copy this here wheel",
    "Create your own": "Create yer own",
    "Error": "Shiver me timbers!",
    "Free and easy to use": "Free an' easy to use. Used by teachers an' fer raffles. Enter names an' spin the wheel to pick a random winner. Customize look an' feel, save an' share wheels.",
    "Frequently Asked Questions": "Questions Ye Landlubbers Be Askin'",
    "It looks like you are using Internet Explorer": "It looks like you are using Internet Explorer. That browser will soon stop receiving security updates from Microsoft. This puts you and us at great risk.\nSoon you will not be able to use this website with Internet Explorer. Please download another browser by doing an online search for \"download web browser\". Any modern browser will do, for example Chrome, Firefox, or Edge.",
    "Loaded default names and options": "Preset crew members and options",
    "Random name picker": "Random name picker",
    "Removed": "{name} walked the plank",
    "Removing winner in": "Removing winner in {seconds} seconds",
    "Report bad ad": "Report bad ad",
    "Warning": "Warning",
    "We try to display only legitimate and honest ads": "We try to display only legitimate an' 'onest ads.",
    "authError": "That there did nay work. Please try again an' ye be prompted to sign in. If it still doesn't work, try these things: refresh the page with ctrl+shift+arrrr (Windows, Linux, Chromebook) or command+shift+arrrrr (Mac), turn off yer ad-blocker, turn off yer anti-virus software."
  },
  "faq": {
    "How do I use this app": "How do I use this 'ere app, matey?",
    "This app lets you spin a wheel": "This 'ere app lets ye spin a wheel o' fortune",
    "Can I save my wheel": "Can I save me wheel fer later?",
    "Yes, if you create an account": "Aye, if ye sign up fer a pirate's account",
    "Is this app free": "Be this app free o' charge?",
    "Yes, this app is completely free": "Aye, this app be free as the seven seas"
  },
  "appInfo": {
    "Terms of service": "Terms o' service",
    "Version": "Version"
  },
  "common": {
    "Cancel": "Fall back",
    "Close": "Close",
    "Continue": "Continue",
    "Customize": "Customize",
    "Delete": "Scratch",
    "Edit description": "Edit description",
    "Edit title": "Change course",
    "Edit title and description": "Edit title and description",
    "If you dont see a Google login button below": "If ye don't see a google login button below, it be probably because ye be usin' an ad-blocker that there mistakenly thinks the button be an ad.",
    "Link Google Account": "Link yer Google Account, matey",
    "Link Google Sheet": "Link yer Google Sheet, arr",
    "Link Google Spreadsheet": "Add Website Sheet",
    "My account": "Me account",
    "OK": "OK",
    "Open": "Open yer chest",
    "Privacy policy": "Privacy policy",
    "Report offensive content": "Report offensive content",
    "Save": "Save",
    "Sign in with Google": "Sign in with Google, ye scallywag",
    "Sign in": "Sign in, matey",
    "Create account": "Create yer account",
    "or": "or",
    "Email": "Parrot mail",
    "Password": "Secret code",
    "Display name": "Yer name on display",
    "Display name is required": "Ye must enter a name, matey",
    "Sign in instead": "Sign in instead, matey",
    "Use this in the classroom": "Use this here in the classroom",
    "We have a winner!": "We 'ave a winner!",
    "Wheel description": "Wheel description",
    "Wheel title": "Wheel title",
    "Max": "Max",
    "Move down": "Drop down",
    "Move up": "Hoist up"
  },
  "nameTabs": {
    "Clear the list": "Clearrr the list",
    "Entries": "Entries",
    "Hide": "Stash",
    "Results": "Results"
  },
  "opendialog": {
    "Are you sure": "Ye sure ye want to scratch \"{wheelTitle}\"? This cannot be undone.",
    "Delete wheel": "Scratch that plan",
    "No wheels found": "No wheels found in yer account. Try savin' a wheel!",
    "Open wheel": "Open me wheel",
    "To open wheels": "To open me wheels, you need to sign into an account.\nPlease choose ye sign-in method below."
  },
  "optionsdialog": {
    "After spin": "After ye spin",
    "All names in the text-box": "All names in the text-box 'ave the same chance o' winning, regardless o' this here value.",
    "Animate winning entry": "'ave winnin' entry animated",
    "Appearance": "Appearrrance",
    "Apply a theme": "Make ye flag",
    "Auto-remove winner after 5 seconds": "Auto-kill winner after 5 seconds",
    "Background color": "Page backgroun' color",
    "Center text": "Centerrr script",
    "Colors": "Colours",
    "Colors tooltip": "Click the color swatches to modify them",
    "Contours": "Contours",
    "Custom": "Custom",
    "Customize colors": "Change colours",
    "Disabled because the entries": "Disabled 'cause the entries have differing ballast",
    "Display Hide button": "Display the \" 'ide\" button",
    "Display Remove button": "Display th' \"Remove\" button",
    "Display duplicates": "Display duplicates",
    "Display every entry": "Display every entry in the textbox as an entry on the wheel, even duplicates",
    "Display popup with message:": "Display ye popup with message:",
    "During spin": "During ye spin",
    "From Gallery": "From wall of maps",
    "Image": "Draw me map",
    "Image in the center of the wheel": "Map in center of ye wheel",
    "Image size": "Image size",
    "Launch confetti": "Confetti cannons!",
    "Max names on wheel": "Max crew members",
    "No": "Nay",
    "One color": "One color per section",
    "Options": "Pirate options",
    "Pick category": "Choose what type we are",
    "Pick theme": "Choose ye crew members' types",
    "Play click sound when the winner is removed": "Play a musket misfire sound when th' winner walks the plank",
    "Remove image": "Remove ye image",
    "Select a gallery picture": "Select a gallery picture",
    "Show title": "Tout the title",
    "Sound": "Sound",
    "Spin slowly": "Spin slow-like",
    "Spin time (seconds)": "Time te spin",
    "Text": "Script",
    "Upload image": "Create map",
    "Volume": "Volume",
    "Wheel background image": "Wheel background image",
    "Yes": "Aye",
    "Your image has been uploaded": "Yer image '{fileName}' been uploaded successfully. Would ye like to use the prominent colors from this here image fer the sectors o' yer wheel?",
    "Advanced mode is enabled": "Advanced pirate mode be enabled, arr!",
    "Sounds": "Sounds",
    "Behavior": "Behavior",
    "Effects": "Effects",
    "Color": "Color"
  },
  "profiledropdown": {
    "Are you sure you want to delete your account": "Be ye sure ye want to delete yer account an' all yer saved wheels? This here action cannot be undone.",
    "Delete account": "Delete account",
    "Delete my account": "Delete me account",
    "Export my data": "Export me data",
    "Sign out": "Retire from me crew",
    "Signed out": "Ye've left the crew",
    "Signed in as": "Yer name is {name}",
    "Anonymous user": "Unknown pirate",
    "Welcome new user": "Welcome aboard Spin the Names! Yer account has been created, matey.",
    "Signed in success": "Successfully signed in, ye scallywag!",
    "Your account and your saved wheels have been deleted": "Yer account an' yer saved wheels 'ave been deleted"
  },
  "savedialog": {
    "Save as": "Save it as",
    "Save wheel": "Save ye wheel",
    "Select a wheel": "Select a wheel",
    "Sorry, too many images": "Yer wheel has too many maps saved to it and ye must scratch some up.",
    "To save wheels": "To save yer wheels, ye need to make an account or make one.\nPlease choose ye sign-in method below.",
    "Wheel saved successfully": "Yer wheel \"{wheelTitle}\" has been saved",
    "You will always be able to access": "Ye will forevermore be able to open yer stashed wheels so long as ye open or stash any wheel at least once every 12 months.",
    "Your existing wheels": "Yer existing wheels"
  },
  "sharedialog": {
    "Copy link": "Copy yer link",
    "Created": "Built",
    "If you continue": "If ye continue, ye will create a public link to yer current wheel, includin' its names, colors an' settings.",
    "Last viewed": "Last spied",
    "Link": "Link",
    "Link copied to the clipboard": "Yer link is copied to me notepad",
    "Link to this wheel": "Link to this wheel with current members, colors, and yer settings:",
    "My shared wheels": "My shared wheels",
    "No wheels found": "No shared wheels found in yer account. Try sharin' a wheel!",
    "See my shared wheels": "See my shared wheels",
    "Shareable link": "Sharable flyers",
    "Show title to people": "Show the title to people who use yer shared link",
    "Sorry, too many images": "Sorry, yer wheel has too many maps to be shared. Scratch some of ye maps and save yer wheel again.",
    "They should be able to spin the wheel and": "Them should be able to spin the wheel an' make a copy o' it",
    "They should only be able to spin the wheel": "They should only be able t' spin th' wheel",
    "This link will work for anyone": "This link will work for all yer crew mates. Derelict links will be scuttled after 365 days.",
    "Visits": "Views",
    "We want this website to be safe place for everyone": "We want this here website to be safe place fer everyone. Wheels that there aren't family-friendly an' that there violate the terms o' service be deleted.",
    "What should a person be able to do": "Wha' should a scallywag be able t' do when they use yer shared link?"
  },
  "sheetdialog": {
    "Column": "Ship Column",
    "First row": "Front row",
    "Is a header and should not be imported": "Be a 'eader an' should not be imported",
    "Link sheet": "Link ye sheet",
    "Select a column": "Select yer column",
    "Select a tab": "Select yer tab",
    "Selected spreadsheet": "Selected spreadsheet",
    "Tab": "Me tab",
    "To import sheets": "To add sheets, ye need to log into yer Google account. Why ye may ask? Google be forcin' us to tell ye so they know who ye be so ye can pick a spreadsheet.",
    "When you link a spreadsheet": "When ye link ye spreadsheet, ye wheel will 'ave the same entries as the spreadsheet. If rows be added or scratched in ye spreadsheet, entries be automatically added an' scratched from ye wheel. The connection will close after one hour.",
    "added": "{entry} added to ye crew",
    "entries added": "{count} crew members added"
  },
  "sounds": {
    "Alarm clock": "Alarm clock",
    "Angel choir": "Angel choir",
    "Announcement bell": "Ship's bell",
    "Applause": "Applause, loud-like",
    "Basketball buzzer": "Basketball buzzer",
    "Bell ringing": "Ship's bell",
    "Bird chirps": "Bird chirps",
    "Boing": "Boing",
    "Boing 2": "Boing 2",
    "Carnival shout": "Carnival shout",
    "Cartoon whistle": "Cartoon whistle",
    "Cat meow": "Cat meow",
    "Childrens hooray": "Young'uns hooray",
    "Cinematic drum impact": "Cinematic drum impact",
    "Cinematic music": "Cinematic music",
    "Correct answer ding": "Aye ding",
    "Crash": "Crash",
    "Cymbals": "Cymbals",
    "Dog bark": "Dog bark",
    "Drum roll": "Drum roll",
    "Easy listening": "Easy listening",
    "Evil laugh": "Evil laugh",
    "Fanfare": "Fanfare",
    "Fireworks": "Ship's cannon",
    "Game win ding": "Game win ding",
    "Ghost": "Ghost",
    "Hooray": "Hooray",
    "Horror scream": "Horror scream",
    "Horse": "Horse",
    "Joke punchline": "Joke punchline",
    "Lion roar": "Lion roar",
    "Lost game": "Lost game",
    "Microwave ding": "Microwave clink",
    "Military trumpet": "Bugle",
    "Mystery bell": "Mystery bell",
    "No sound": "As quiet as death",
    "Notification bell": "Notification bell",
    "Old phone ringing": "Old phone ringin'",
    "Pan flute": "Pan flute",
    "Pop music": "Pop music",
    "Random 8-Bit": "Random 8-Bit",
    "Random ballroom dancing": "Random ballroom dancing",
    "Random cinematic music": "Random cinematic music",
    "Random dance & techno": "Random dance & techno",
    "Random disco": "Random disco",
    "Random easy listening": "Random easy listening",
    "Random electronica": "Random electronica",
    "Random folk music": "Random folk music",
    "Random funk": "Random funk",
    "Random hip hop": "Random hip hop",
    "Random music": "Random music",
    "Random polka": "Random polka",
    "Random pop music": "Random pop music",
    "Random reggae & reggaeton": "Random reggae & reggaeton",
    "Random retro-rock": "Random retro-rock",
    "Random rock music": "Random rock music",
    "Random rockabilly": "Random rockabilly",
    "Random silent film score": "Random silent film score",
    "Random winter holidays": "Random winter holiday music",
    "Random world music": "Random world music",
    "Read out the winning name": "Read out the winnin' name",
    "Read out the winning name (option 1)": "Speak ye winning name (option 1)",
    "Read out the winning name (option 2)": "Speak ye winning name (option 2)",
    "Referee whistle": "Referee whistle",
    "Rock music": "Rock music",
    "Sad trombone": "Sad trombone",
    "Silent film score": "Silent film score",
    "Sound effects": "Sound effects",
    "Subdued applause": "Applause, quiet-like",
    "Swoosh ding": "Swoosh ding",
    "Synth bell": "Synth bell",
    "Taiko drum": "Taiko drum",
    "Thunder": "Thunderr",
    "Ticking sound": "Ticking sound",
    "Twinkling star": "Shinin' star",
    "Water splash": "Water splash",
    "Winter holidays": "Winter holiday music",
    "Wolf howl": "Wolf howl",
    "World music": "World music",
    "Xylophone ascending": "Xylophone ascending"
  },
  "spinningwheel": {
    "Click to spin": "Click te spin",
    "Tap to spin": "Tap te spin",
    "or press ctrl+enter": "er press ctrl+enter"
  },
  "textboxbuttons": {
    "Add image": "Draw me map",
    "Advanced": "Advanced",
    "Revert from advanced": "Reverrrt",
    "Reverting will reset": "If ye revert from advanced mode ye may lose some colors. Be ye sure ye want to continue?",
    "Shuffle": "Mix around",
    "Sort": "Line up"
  },
  "toolbar": {
    "Add your language": "Add yer language",
    "Dark mode": "Pirate mode",
    "Exit fullscreen": "Leave the seven seas",
    "FAQ": "FAQ",
    "Feedback": "Give me yer feedback",
    "Fullscreen": "Wide Sea",
    "Language": "What's yer language",
    "More": "Moreover",
    "New": "New",
    "Offline mode": "Asleep mode",
    "Please enter your email address": "Please enter your email address to continue",
    "Send debug data": "Send debug data",
    "Share": "Share",
    "System theme": "Ship's colors",
    "Theme settings": "Flag settings",
    "Light theme": "Bright like the sun",
    "Dark theme": "Dark as Davy Jones' locker",
    "Light": "Bright",
    "Dark": "Dark",
    "Currently using": "Currently flyin'",
    "Theme": "Flag",
    "Unlink Google Spreadsheet": "Scratch Google Spreadsheet",
    "User reviews and tutorials": "User reviews an' tutorials",
    "Your session is now being recorded": "Yer session be now bein' recorded. Ye can sink the recordin' by closin' yer browser window."
  },
  "winnerdialog": {
    "Hide": "'ide",
    "Remove": "Walk me plank",
    "Remove all instances": "Kill them all!"
  },
  "banner": {
    "setupMessage": "Ahoy there! We be still gettin' things shipshape. Some features may be limited or temporarily unavailable. Thanks fer yer patience, matey!",
    "dismissLabel": "Dismiss the announcement"
  },
  "accountdialog": {
    "Sign in intro": "Sign in to save, share, and manage yer wheels, matey.",
    "Preparing sign-in": "Preparin' sign-in options, arrr…",
    "Troubleshooting title": "Troubleshootin' sign-in, savvy?",
    "Login failed": "Login failed, ye scallywag. Please try again.",
    "Email verified": "Parrot mail be verified",
    "Email not verified": "Parrot mail not yet verified",
    "Resend verification email": "Send the verifyin' parrot again",
    "Verification email sent": "Verification parrot sent. Check yer inbox an' the spam barrel.",
    "Verification email failed": "Could nay send the verification parrot. Try again later."
  }
}
